import SiteStructure from './site-structure'
import EventBus from '../../event-bus'

/* eslint-disable */
class BodyBgClass {
  init () {
    this.setContentID(SiteStructure.getSelectedItem().content)

    // Events
    EventBus.$on('Nav.CHANGE', function (e) {
      BodyBg.setContentID(e.navItem.content)
    })
  }
  setContentID (id) {
    switch (id) {
      // Articles
      case 'articles-list':
        this.setBg('#DADADA')
        break
      // Gallery
      case 'gallery':
        this.setBg('#000000')
        break
      // Labs
      case 'labs':
        this.setBg('#842291')
        break
      // Projects
      case 'projects':
        this.setBg('#6bf3ff')
        break
      // UI-UX
      case 'uiux':
        this.setBg('#f9af2f')
        break
      // Portfolio
      case 'lincoln-virtual-car-config':
        this.setBg('#08141b')
        break
      case 'galaxy-idd':
        this.setBg('#48443F')
        break
      case 'ford-autoshows':
        this.setBg('#193361')
        break
      case 'hkwd':
        this.setBg('#ADD029')
        break
      case 'asos-urban-tour':
        this.setBg('#F4F4F4')
        break
      case 'philips-obsessed-with-sound':
        this.setBg('#343D4F')
        break
      case 'sncf-les-petits-services':
        this.setBg('#0E1340')
        break
      case 'cadbury-youtube-dance-off':
        this.setBg('#3D2770')
        break
      case 'copp-susmakeover':
        this.setBg('#5A7B2E')
        break
      case 'mount-franklin-wop':
        this.setBg('#EFFAFF')
        break
      case 'triumph-you-are-wonderful':
        this.setBg('#E1252B')
        break
      case 'coke-zero-trust-your-buds':
        this.setBg('#000000')
        break
      case 'portfolio-overview':
        this.setBg('#4230ef')
        break
      case 'pacific-place-idd':
      case 'london-work-campaign-ar':
      case 'adidas-schneller-ins-trikot':
      case 'nike-nba-connected-jersey':
      case 'nike-wechat-campaigns':
        this.setBg('#fdfdfd')
        break
      default:
        this.setBg(null)
    }
  }
  setBg (colour) {
    if (colour) {
      document.body.style.background = colour
    } else {
      document.body.style.background = '#fdfdfd'
    }
  }
}

const BodyBg = new BodyBgClass()

export default BodyBg
